<template>
  <div class="row">
    <div class="col-md-12 input-position text-center">
      <div class="btn-group" role="group" aria-label="...">
        <button
          type="button"
          @click="modal.infos = true"
          class="btn btn-white btn-small"
        >
          <i class="k-icon-location"></i> {{ $t('button.information') }}
        </button>
        <button
          type="button"
          @click="modal.reviews = true"
          class="btn btn-white btn-small"
        >
          <i class="k-icon-star"></i> {{ $t('button.reviews') }}
        </button>
        <button type="button"
          @click="modal.deals = true"
         class="btn btn-white btn-small">
          <i class="k-icon-tag"></i> {{ $t('button.deals') }}
        </button>
      </div>
    </div>
    <modal
      :ignoreBackdropClick="true"
      :show.sync="modal.infos"
      headerClasses="justify-content-center"
      class="modal-options"
      v-if="selectedLocation != null"
      modalClasses="modal-dialog-centered modal-dialog-scrollable"
    >
      <h4 slot="header" class="title title-up">{{ $t("text.information") }}</h4>
      <div class="container">
        <div class="row location-information">
          <div class="left-column">
            <location-infos></location-infos>
          </div>
        </div>
      </div>
    </modal>
    <modal
      :ignoreBackdropClick="true"
      :show.sync="modal.deals"
      headerClasses="justify-content-center"
      class="modal-options"
      v-if="selectedLocation != null"
      modalClasses="modal-dialog-centered modal-dialog-scrollable"
    >
      <h4 slot="header" class="title title-up">{{ $t("text.deals") }}</h4>
     <deals-Items :coupons="availableCoupons" :isHome="true"></deals-Items>
    </modal>

     <modal
      :ignoreBackdropClick="true"
      :show.sync="modal.reviews"
      headerClasses="justify-content-center"
      class="modal-options"
      v-if="selectedLocation != null"
      modalClasses="modal-dialog-centered modal-dialog-scrollable"
    >
      <h4 slot="header" class="title title-up">{{ $t("text.reviews") }}</h4>
     <location-reviews></location-reviews>
    </modal>
    
  </div>
</template>
<script>
import { Button, Modal } from "@/components";
import { DealsItems, LocationReviews, LocationInfos } from '@/views/components';
export default {
  components: {
    [Button.name]: Button,
    LocationInfos,
    Modal,
    DealsItems,
    LocationReviews,
  },
  data() {
    return {
      modal :{
        infos:false,
        deals : false,
        reviews : false,
      }
    };
  },
  props: {
    cart: Object,
  },
  computed : {
    availableCoupons() {
      if (
        !this.selectedLocation ||
        !this.selectedLocation.coupons ||
        !this.selectedLocation.coupons.length
      )
        return [];
      return this.selectedLocation.coupons.filter((c) => !c.auto_applied);
    },
  },
};
</script>

